import { z } from 'zod';

import {
  createEntityAdapterSchema,
  findDuplicateIds,
  findDuplicateNames,
} from '../../base';
import { EntitySchema } from './entities.schema';

// Entities collection schema
export const EntitiesSchema = z
  .object({
    entities: createEntityAdapterSchema(EntitySchema),
  })
  .superRefine((data, ctx) => {
    const entities = Object.values(data.entities.entities);
    const duplicateNames = findDuplicateNames(entities);
    const duplicateIds = findDuplicateIds(entities);
    for (const duplicate of duplicateNames) {
      ctx.addIssue({
        path: ['entities', 'entities', duplicate.id, 'name'],
        code: z.ZodIssueCode.custom,
        message: 'Duplicate name',
      });
    }
    for (const duplicate of duplicateIds) {
      ctx.addIssue({
        path: ['entities', 'entities', duplicate.id, 'id'],
        code: z.ZodIssueCode.custom,
        message: 'Duplicate ID',
      });
    }
  });

export type Entities = z.infer<typeof EntitiesSchema>;
